export default __webpack_public_path__ + "static/media/log-in.79f95d9c.svg";